import React, { Component } from 'react';
import 'antd/dist/antd.css';
import './Login.css';
import { Form, Icon, Input, Button, Modal, Spin, Progress } from 'antd'
import axios from 'axios'
import { Constants, Odata_Url } from '../../../Constants/Constants'
import { connect } from 'react-redux'
import languageData from '../../../Constants/Data'
import IntlMessages from '../../../util/IntlMessages'
import { Checkbox } from 'antd';
import icon_thailand from '../images/icon.thailand.png';
import icon_england from '../images/icon.america.png'
import classNames from 'classnames'


const FormItem = Form.Item;
// const { getArea, getShift, getObservertype, getRootcause, getJobtype, getCategory, getSub_Category, getCompany } = Service_getdata
class Login extends Component {

  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      loading: false,
      remember_me: false,
      percent: 0,
      location: '',
      render: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
      this.props.SET_AUTHENTICATION();

      let location = this.props.location.state ? (this.props.location.state || {}).from.pathname : '/';
      console.debug("Login.componentWillMount.location", location);
      this.setState({
          location: location,
          render: true
      });

      axios.get("auth/token").then(authTokenResp => {
          console.debug("get token pass with", authTokenResp.data);

          let Token = authTokenResp.data;
          var tokenHeader = { headers: { "Authorization": "Bearer " + Token } };

          this.getMDData(Token).then(() => {

              this.props.ClearState2();
              this.props.set_status("success");

              axios.get("api/MDMMemberInfo/MemberInfoCurrent", tokenHeader).then(memberInfoCurrentResp => {
                  if (memberInfoCurrentResp.data && memberInfoCurrentResp.data.responseData && memberInfoCurrentResp.data.responseData.length > 0) {

                      let memberInfoDataResp = memberInfoCurrentResp.data.responseData[0];

                      let User_Info = {};
                      User_Info.UserFullName_ENG = memberInfoDataResp.e_FullName;
                      User_Info.UserFullName_TH = memberInfoDataResp.t_FullName;
                      User_Info.email = memberInfoDataResp.email;
                      window.localStorage.setItem("User_Info", JSON.stringify(User_Info))
                      window.localStorage.setItem('authen', memberInfoDataResp.adAccount);

                      this.get_data_after_register(memberInfoDataResp.adAccount);
                  }
              });
          });

      }).catch(function (error) {
          if (error.response) {
              console.debug("get token err", error.response.status);
              if (401 === error.response.status) {
                  window.location.href = "auth";
              }
          }
      });
    }

    getMDData(Token) {
        let $getArea = axios.get(
            Odata_Url + 'OAreaMD?$filter=IsActived eq true&$orderby=Name',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                //console.log(data);
                window.localStorage.setItem('Area', JSON.stringify(data));
            }, (error) => {
                console.log(error);
            });

        let $getObType = axios.get(
            Odata_Url + 'OObserverTypeMD?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                // console.log(data);
                window.localStorage.setItem('Observertype', JSON.stringify(data));
            }, (error) => {
                console.log(error);
            });

        let $getRootC = axios.get(
            Odata_Url + 'ORootcauseMD?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                // console.log(data);
                window.localStorage.setItem('Rootcause', JSON.stringify(data));
            }, (error) => {
                console.log(error);
            });
        let $getJobType = axios.get(
            Odata_Url + 'OJobType?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                // console.log(data);
                window.localStorage.setItem('Jobtype', JSON.stringify(data));
            }, (error) => {
                console.log(error);
            });
        let $getCat = axios.get(
            Odata_Url + 'OCategoryMD?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                // console.log(data);
                window.localStorage.setItem('Category', JSON.stringify(data));
            }, (error) => {
                console.log(error);
            });
        let $getSubCat = axios.get(
            Odata_Url + 'OSub_Category?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                // console.log(data); 
                window.localStorage.setItem('Sub_Category', JSON.stringify(data));
            }, (error) => {
                console.log(error);
            });
        let $getCom = axios.get(
            Odata_Url + 'OCompanyMD?$filter=IsActived eq true',
            { headers: { "Authorization": "Bearer " + Token } }).then((response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                // console.log(data);
                window.localStorage.setItem('Company', JSON.stringify(data));
            },
                (error) => {
                    console.log(error);
                });

        return Promise.all([$getArea, $getObType, $getRootC, $getJobType, $getCat, $getSubCat, $getCom]);
    }

  initData() {
      console.debug("Login.initData", {
          Odata_Url: Odata_Url
      });
      
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true,
        })
        //console.log('Received values of form: ', values);
        this.login(values.username.toLowerCase(), values.password)
      }
    });
  }

  login = (username, password) => {
    // console.log(Constants.BASE_URL)
    var og_username = username;
    username = username.split("@")[0]
    var res_password = encodeURIComponent(password)
    axios.get(Constants.BASE_URL + 'api/MDM/ChemVerifySSO?username=' + og_username + '&password=' + res_password)
      .then((response) => {
        // console.log(response)
        
      },
        (error) => {
          console.log(error);
        })
  }

  get_data_after_register(username) {
    var Token
    axios.get(Constants.BASE_URL + 'auth/token')
      .then((response) => {
        Token = response.data

        axios.get(
          Odata_Url + `OUserMD?$filter=IsActived eq true and tolower(User_Name) eq '` + username + `'`,
          {
            headers: {
              "Authorization": "Bearer " + Token,
            }
          }
        )
          .then((response) => {
            var UserID
            var CompanyID
            var RoleID
            response.data.value.forEach(function (element) {
              UserID = element.PKUserID
              CompanyID = element.CompanyID
              RoleID = element.RoleID
            });
            window.localStorage.setItem("RoleID", RoleID)
            window.localStorage.setItem("UserID", UserID)
            window.localStorage.setItem("CompanyID", CompanyID)

            window.localStorage.setItem("User_Info", JSON.stringify(response.data.value[0]));

            this.props.set_userid(UserID)
            this.props.set_companyid(CompanyID)
            this.props.history.push(this.state.location);
          },
            (error) => {
              console.log(error);

            })
      },
        (error) => {
          console.log(error)
        });

  }

  checkImage(imageSrc, good, bad) {
    var img = new Image();
    img.onload = good;
    img.onerror = bad;
    img.src = imageSrc;
  }
  fail() {
    Modal.error({
      title: 'Username or password is incorrect',
      content: '',
    });
  }
  verifyfail() {
    Modal.error({
      title: "Access Denied! You don't have authorized.",
      content: '',
    });
  }

  verifyUserMDFail() {
    Modal.error({
      title: 'Error!!',
      content: 'User not found, please contact administrator.',
    });
  }

  onchangeEN = () => {

    this.props.SWITCH_LANGUAGE(languageData[0]);

  }
  onchangeTH = () => {

    this.props.SWITCH_LANGUAGE(languageData[1]);

  }
  remember_me = () => {
    this.setState({
      remember_me: true
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const username = window.localStorage.getItem('Username')
    const password = window.localStorage.getItem('Password')
    if (username !== "null" && password !== "null") {
      var initialValue_username = username
      var initialValue_password = password
    }


    return (
      this.state.render ?
        //<div className="body1" >
        //  <div className="body2" >
        //    <Spin spinning={false} size="large" style={{ marginTop: "40%" }} tip="Loading...">
        //      <div className={classNames({
        //        'body3': true,
        //        'body3-1': 0 !== this.state.percent,
        //      })} >
        //        <div style={{ textAlign: "center" }} >
        //          <img style={{ width: '80%' }} src="/scg-logo-red.png" alt="logo" />
        //        </div>
        //        <div className="content" >
        //          <Form onSubmit={this.handleSubmit} style={{ marginTop: "20px" }}>
        //            <FormItem>
        //              {getFieldDecorator('username', {
        //                rules: [{ required: true, message: <IntlMessages id="signin.please.input.username" /> }],
        //                initialValue: initialValue_username,
        //              })(
        //                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)', borderColor: "black" }} />} placeholder="Username" />
        //              )}
        //            </FormItem>
        //            <FormItem>
        //              {getFieldDecorator('password', {
        //                rules: [{ required: true, message: <IntlMessages id="signin.please.input.password" /> }],
        //                initialValue: initialValue_password,
        //              })(
        //                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
        //              )}
        //            </FormItem>
        //            <div>
        //              <Checkbox onChange={this.remember_me}><IntlMessages id="signin.remember_me" /></Checkbox>
        //              <img onClick={this.onchangeTH} alt="TH" src={icon_thailand} style={{ width: "25px", height: "25px", float: "right" }} />
        //              <img onClick={this.onchangeEN} alt="EN" src={icon_england} style={{ width: "25px", height: "25px", marginRight: "20px", float: "right" }} />
        //            </div>
        //            <Button loading={this.state.loading} htmlType="submit" className="login-form-button" style={{ width: "100%", marginTop: "20px", backgroundColor: "rgb(0,152,139)" }}>
        //              <span style={{ color: "white" }}><IntlMessages id="signin.singin" /></span>
        //            </Button>
        //          </Form>
        //        </div>
        //      </div>
        //    </Spin>
        //    {
        //      (this.state.loading) && (
        //        <Progress style={{ position: "absolute", background: "lightblue", borderRadius: "50%" }} type="circle" percent={this.state.percent} />
        //      )
        //    }
        //  </div>
        //</div >
        <></>
        :
        <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <h3>Authenticating...</h3>
        </div>

    );

  }
}


const mapStatetoProps = (state) => {
  return {
    authen: state.authen,
    setting: state.setting,
  }
}

const mapDispatchProps = (dispatch) => {
  return {
    SWITCH_LANGUAGE: (value) => {
      dispatch({
        type: "SWITCH_LANGUAGE",
        locale: value
      })
    },
    set_status: (value) => {
      dispatch({
        type: "Set_status",
        status: value
      })
    },
    set_userid: (value) => {
      dispatch({
        type: "Set_userid",
        UserID: value
      })
    },
    set_companyid: (value) => {
      dispatch({
        type: "Set_companyid",
        CompanyID: value
      })
    },
    ClearState2: () => {
      dispatch({
        type: "ClearState2",
      })
    },
    SET_AUTHENTICATION: () => {
      dispatch({
        type: "SET_AUTHENTICATION",
      })
    },
  }
}

const WrappedLogin = Form.create()(Login);
export default connect(mapStatetoProps, mapDispatchProps)(WrappedLogin)